import React, {
  useCallback,
} from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useIntl } from 'react-intl'

import { useModalDialog } from '@termly-web/common'

import Styles from './styles.scss'


export default function Modal(props) {
  const {
    ariaLabel,
    children,
    handleClickOutside,
  } = props

  const { formatMessage } = useIntl()
  const {
    closedby,
    dialogRef,
    onCancel,
    onClose,
  } = useModalDialog({
    handleCancel: handleClickOutside,
  })

  const formattedAriaLabel = ( ariaLabel?.id && ariaLabel?.defaultMessage )
    ? formatMessage(ariaLabel, ariaLabel.values)
    : ariaLabel

  const onClick = useCallback((e) => {
    if ( !handleClickOutside ) {
      return
    }

    e.stopPropagation()

    handleClickOutside()
  }, [handleClickOutside])

  const containerClassName = classnames(Styles.container, 't-container')

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: Escape is handled natively via `onCancel`
    <dialog
      aria-label={ formattedAriaLabel }
      className={ Styles.root }
      closedby={ closedby }
      onCancel={ onCancel }
      onClick={ onClick }
      onClose={ onClose }
      ref={ dialogRef }
    >
      <div className={ Styles.viewport }>
        {/* biome-ignore lint/a11y/noStaticElementInteractions: wrapper only keeps events inside the modal */}
        <div
          className={ containerClassName }
          onClick={ onContainerClick }
          onKeyDown={ onContainerKeyDown }
        >
          { children }
        </div>
      </div>
    </dialog>
  )
}

Modal.propTypes = {
  ariaLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      defaultMessage: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      values: PropTypes.shape({}),
    }),
  ]),
  children: PropTypes.node,
  handleClickOutside: PropTypes.func,
}

function onContainerClick(e) {
  e.stopPropagation()
}

function onContainerKeyDown(e) {
  e.stopPropagation()
}
